export default __webpack_public_path__ + "static/eden_landing-1157edd8dd687643715884fe325cfe71.png";